import useAppSelector from 'hooks/useAppSelector';
import Text from '../Text';
import styled from 'styled-components/macro';
import getImage, { ImageType } from 'utils/getImage';
import { getProductLink } from 'utils/getProductLink';
import { ImageExtension } from 'microshop-api';
import useAppDispatch from 'hooks/useAppDispatch';
import { selectFeaturedProductsInfo } from 'store/reducers/shopSlice';
import { loadProducts } from 'store/reducers/assortmentSlice';
import { useEffect } from 'react';
import CardSection, { Card, CardImageFrame, CardImageLink, CardImage } from './CardSection';

const FeaturedProducts = () => {
    const dispatch = useAppDispatch();

    const { categories, products } = useAppSelector(({ assortment }) => assortment);
    const featuredProductsInfo = useAppSelector(selectFeaturedProductsInfo);

    useEffect(() => {
        dispatch(loadProducts());
    }, [dispatch]);

    if (!products.length) return null;

    return (
        <CardSection
            title={featuredProductsInfo?.title}
            titleAlign="center"
            arrowVerticalPosition="45%"
            overflow="visible"
        >
            {products.map((product, index) => (
                <Card key={index}>
                    <CardImageLink to={getProductLink(product, categories)}>
                        <CardImageFrame $aspectRatio="305 / 322">
                            {product.image && (
                                <CardImage
                                    itemProp="image"
                                    src={getImage(product?.image, ImageType.Preview, ImageExtension.Jpg)}
                                    alt={product?.productName || 'product'}
                                    $width="100%"
                                    $height="90%"
                                />
                            )}
                        </CardImageFrame>
                    </CardImageLink>
                    <Name bold>{product.productName}</Name>
                    <Price bold>{product?.price?.str}</Price>
                </Card>
            ))}
        </CardSection>
    );
};

const Name = styled(Text)`
    margin-left: 12px;
    text-align: left;
    width: 100%;
    font-weight: 700;
`;

const Price = styled(Text)`
    margin-left: 12px;
    text-align: left;
    width: 100%;
    font-size: 16px;
`;

export default FeaturedProducts;
